import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import passIcon from '../assets/pass-icon.png';
import noiseIcon from '../assets/noise-icon.png';
import ccremoteIcon from '../assets/ccremote-icon.png';
import { trackPageView } from '../utils/analytics';

const timelineData = [
  {
    date: 'Mar 2026',
    title: 'CC Remote v1.0',
    icon: ccremoteIcon,
    description: 'First release of CC Remote — monitor and control Claude Code sessions from your iPhone or iPad over local network.',
    tags: ['New App', 'iOS'],
  },
  {
    date: 'Feb 2026',
    title: 'Retro Noise v1.0',
    icon: noiseIcon,
    description: 'Retro Noise launched on the App Store. Generate ambient noise with a retro aesthetic.',
    tags: ['New App', 'iOS'],
  },
  {
    date: 'Jan 2026',
    title: 'ZipWithPassword v1.0',
    icon: passIcon,
    description: 'ZipWithPassword launched on the Mac App Store. Compress and encrypt files with password protection.',
    tags: ['New App', 'macOS'],
  },
  {
    date: 'Jan 2026',
    title: 'PeaceTech Website',
    icon: null,
    description: 'PeaceTech official website goes live. Making simple and interesting things.',
    tags: ['Website'],
  },
];

const Timeline = () => {
  useEffect(() => {
    trackPageView('Timeline');
  }, []);

  return (
    <div className="timeline-container">
      <header className="timeline-header">
        <h1>Timeline</h1>
        <p>Our release history and milestones.</p>
      </header>

      <div className="timeline">
        <div className="timeline-line" />
        {timelineData.map((item, index) => (
          <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
            <div className="timeline-dot">
              {item.icon ? (
                <img src={item.icon} alt={item.title} className="timeline-dot-icon" />
              ) : (
                <div className="timeline-dot-default" />
              )}
            </div>
            <div className="timeline-card">
              <span className="timeline-date">{item.date}</span>
              <h3 className="timeline-title">{item.title}</h3>
              <p className="timeline-desc">{item.description}</p>
              <div className="timeline-tags">
                {item.tags.map((tag, i) => (
                  <span key={i} className="timeline-tag">{tag}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="timeline-back">
        <Link to="/" className="back-link">← Back to Home</Link>
      </div>
    </div>
  );
};

export default Timeline;
